import { getProjectPath } from '@/utils'
import type { Transaction } from './stores/types'

export const transactionKey = (
  input: Pick<Transaction, 'date' | 'amount'>,
): string => `${input.date}|${input.amount}`

// The browser's own PDF viewer honours a `#page=N` anchor, so a link can land on the right page.
export const statementPageUrl = (
  fileUrl: string,
  page?: number | null,
): string => (page ? `${fileUrl}#page=${page}` : fileUrl)

const PROJECT_SECTION_TITLES: Record<string, string> = {
  '': 'Overview',
  files: 'Files',
  workbench: 'Workbench',
  transactions: 'Transactions',
  portfolio: 'Portfolio',
  checks: 'Checks',
  insights: 'Insights',
  analysis: 'AI Analysis',
}

const INSIGHTS_SECTION_TITLES: Record<string, string> = {
  coverage: 'Coverage',
  categories: 'Categories',
  reconciliation: 'Statement cycles',
  income: 'Income',
  merchants: 'Merchants',
  duplicates: 'Duplicates',
  anomalies: 'Anomalies',
  checks: 'Checks',
  network: 'Network',
  'flow-of-funds': 'Flow of funds',
}

export const projectSectionTitle = (pathname: string, slug: string): string => {
  const base = getProjectPath({ slug })
  const rest = pathname.startsWith(base) ? pathname.slice(base.length) : ''
  const [section = '', subSection = ''] = rest.replace(/^\/+/, '').split('/')

  if (section === 'insights' && INSIGHTS_SECTION_TITLES[subSection]) {
    return INSIGHTS_SECTION_TITLES[subSection]
  }

  return PROJECT_SECTION_TITLES[section] ?? 'Overview'
}
